// Header height
jQuery(document).ready(function($) {

    jQuery(window).resize(function() {

        $('.banner-content').css('margin-top', $('.page-header').outerHeight() + 'px');

    }).resize();

});  